export const iconFontAwesomeHandsHandHoldingHeart = (
	<i className="fa-solid fa-hand-holding-heart"></i>
);
